import { validateUrls } from "api/types"

export const urls = validateUrls({
  schedule: () => `/v1/users/planners/items/calendar/`,
})
